import React, { useEffect, useRef, useState } from "react";
import Image from "../../components/common/Image";
import Toggle from "../../components/common/toggle";
import Input from "../../components/common/Input";
import {ReactComponent as Car} from '../../assets/car.svg'
import { TakeFiling } from "../../api/order";
import { useSelector } from "react-redux";
import Select from "../../components/common/Select";

const Record = ({setStep, OrderId,onSubmit }) => {
    const carRef = useRef()
    const parameters = useSelector(state=>state.global.parameters)
    const [page, setPage] = useState(1)
    const [selected, setSelected] = useState({3:{},4:{}})
    const [submitData, setSubmitData] = useState({})
    const [submiting, setSubmiting] = useState(false)
    const hurtOptions=[
        { id: 1, name: "有受傷",value: "有受傷" },
        { id: 2, name: "無受傷",value: "無受傷" },
        { id: 3, name: "身故",value: "身故" },
    ]
    let onChange = (key,val)=>{
        let obj ={...submitData}
        if(!val){
            delete obj[key]
        }else{
            obj[key] = val
        }
        setSubmitData(obj)
    }
    const btnDisabled = ()=>{
        let unvalid = true
        if(page >2){
            unvalid = false
        }else{
            let length = page ===1? 6: 12
            let step_1 = submitData.ourAccidentCar?6:5
            if(page === 1){
                // submitData
                length = step_1
            }else{
                length = submitData.theyAccidentCar? step_1+6 : step_1+5
            }
            unvalid =  Object.keys(submitData).length < length
        }
        return unvalid
    }
    const submit = async ()=>{
        if(page > 2){
            let key = page===3? "ourAccidentCar": "theyAccidentCar"
            setSubmitData({...submitData, [key]:selected[page] })
            setPage(page-2) 
            

        }else{
            if(page ===1) {
                setPage(page+1)
            }else{
                setSubmiting(true)
                let obj = {OrderId}
                Object.keys(submitData).forEach(key=>{
                    if(key === 'theyAccidentCar' || key === 'ourAccidentCar'){
                        obj[key] = Object.keys(submitData[key]).map(car=> parseInt(car))
                        
                    }else if(typeof(submitData[key])=== 'object'){
                        obj[key] = submitData[key]?.value
                        // submitData[key] = submitData[key]['name']==='行人'? false : true
                    }else{
                        obj[key]  = submitData[key]
                    }
                })
                let res = await TakeFiling(obj)
                if(res?.statusCode === 200){
                    onSubmit()
                }
                setSubmiting(false)
            }
        }
    }
    
    useEffect(()=>{
        if(carRef.current){
            for(let path of carRef.current.children[0].children){
                let name = path.getAttribute("name")
                if(name){
                    path.style.fill = selected[page][name]? 'rgba(255, 181, 162, 1)':null
                }
            }
        }
    },[selected,page])
    useEffect(()=>{
        // document.querySelector("body").
        window.scrollTo(0, 0);
    },[page])
    const toSvg = (e)=>{
        let obj= selected[page]
        let name = e.target.getAttribute("name")
        if(name){
            if(obj[name]){
              delete obj[name]
            }else{
                obj[name] = true
            }
            // e.target.style.fill = obj[name]? 'rgba(255, 181, 162, 1)':null
            // let select_obj ={...selected}
            // 
            // console.log({...selected, [page]:obj})
            setSelected({...selected, [page]:obj})
        }
    }
    return (
        <div className="grid-gap-24">
            <div className="page-header">
                <button className="btn-circle" onClick={() =>{
                    if(page > 2){
                        setPage(page-2)
                    }else{
                        setStep(1)
                        setSelected({3:{},4:{}})
                    }
                    
                }}>
                    <Image src="/images/icons/close.svg" svg />
                </button>
                <div className="page_header__title">
                    <h1 className="font-heading">{page === 1 ? '我方事故備案紀錄' : 
                        page === 2?'他方事故備案紀錄':'車輛損傷'}</h1>
                    <p className="text-secondary text-scale-02">
                        {page < 3?
                            '保險公司可能需要相關的事故資料作為索賠依據，備案內容有助於簡化後續理賠流程。' : '點擊即可標示受損部位，再次點擊即可取消。'}

                    </p>
                </div>
            </div>
            {
                page === 1 && (<>
                   
                    <Input label="駕駛人姓名" 
                        defaultValue={submitData.driverName}
                        placeholder="請輸入證件本名" 
                        // rules={
                        //     [{ pattern: new RegExp(/^[a-zA-Z0-9]*$/), 
                        //     message: '請輸入半形英數字，不需包含「-」符號。' }] 
                        //     }
                         onChange={(data) =>  onChange("driverName",data)}
                    />
                    <Select
                        label='事故種類'
                        placeholder="點擊選擇"
                        defaultValue={submitData.accidentType}
                        options={parameters?.AccidentType.data}
                        onChange={(data) =>  onChange("accidentType",data)}

                        />
                    <Select
                        label='現場狀況'
                        placeholder="點擊選擇"
                        defaultValue={submitData.accidentDesc}
                        options={parameters?.AccidentDescType.data}
                        onChange={(data) =>  onChange("accidentDesc",data)}
                        />
                    <Toggle
                        label="我方受傷情形"
                        info="我方：駕駛及同車乘客"
                        defaultValue={submitData.ourHurt}
                        list={hurtOptions}
                        onChange={(data) => {
                            setSubmitData({...submitData,ourHurt:data})
                        }}
                    />
                    <Toggle
                        label="事故是自撞造成的嗎？"
                        defaultValue={submitData.isSelfCollision}
                        list={[
                            { id: 1, name: "是", value:true },
                            { id: 2, name: "否", value:false },
                        ]}
                        onChange={(data) =>  onChange("isSelfCollision",data)}

                    />
                    <div className='confirm-block' style={{ marginTop: 0, }}>
                        <div className="block">
                            <div className="list_block info_block">
                                <div className="desc_flex">
                                    <Image src="/images/icons/check.svg" />
                                    <div className="title_block">
                                        <p className="title">設定我方車損情形</p>
                                    </div>
                                </div>
                                <div
                                    onClick={() => setPage(3)}
                                >
                                    <Image src="/images/icons/chevron_right.svg" svg />
                                </div>
                            </div>
                        </div>
                    </div>
                </>)
            }
            {
                page === 2 && (<>
                    <Toggle
                        defaultValue={submitData.isTheyDrive}
                        label="對方有開車嗎？"
                        list={[
                            { id: 1, name: "行人", value:false },
                            { id: 2, name: "開、騎車", value: true},
                        ]}
                        onChange={(data) => {
                            setSubmitData({...submitData,isTheyDrive:data})
                        }}
                    />
                    <Input label="對方車牌號碼" 
                        defaultValue={submitData.theyPlateNum}
                        placeholder="不需輸入”-”，例）ABC123" 
                        rules={
                            [{ pattern: new RegExp(/^[a-zA-Z0-9]*$/), 
                            message: '請輸入半形英數字，不需包含「-」符號。' }] 
                            }
                         onChange={(data) =>  onChange("theyPlateNum",data)}
                    />
                    <Input label="對方姓名" 
                        defaultValue={submitData.theyName}
                    placeholder="請輸入證件本名"
                     onChange={(data) => onChange("theyName",data)} />
                    <Input label="對方電話" 
                        defaultValue={submitData.theyPhone}
                    placeholder="例）0912345678"
                    onChange={(data) => onChange("theyPhone",data)}
                     />
                    <Toggle
                        label="對方受傷情形"
                        info="對方：對方全車人員"
                        defaultValue={submitData.theyHurt}
                        list={hurtOptions}
                        onChange={(data) => {
                            setSubmitData({...submitData,theyHurt:data})
                        }}
                    />
                    <div className='confirm-block' style={{ marginTop: 0, }}>
                        <div className="block">
                            <div className="list_block info_block">
                                <div className="desc_flex">
                                    <Image src="/images/icons/check.svg" />
                                    <div className="title_block">
                                        <p className="title">設定對方車損情形</p>
                                    </div>
                                </div>
                                <div
                                    onClick={() => setPage(4)}
                                >
                                    <Image src="/images/icons/chevron_right.svg" svg />
                                </div>
                            </div>
                        </div>
                    </div>
                </>)
            }
            {
                page >2 &&(<div
                className="car-svg-block"
                >
                    <Car 
                    ref={carRef}
                    onClick={toSvg}/>
                </div>)
            }
           
            <button 
            disabled={btnDisabled() || submiting}
            onClick={submit}
            className="btn">{page < 3 ?'下一步':'確定'}</button>
        </div>
    );
};

export default Record;
